/**
 * Edge utility functions
 */

/**
 * Create muted version of a color (50% opacity)
 */
export const getMutedColor = (color) => {
  if (!color) return 'rgba(255, 255, 255, 0.5)';
  // If it's a hex color, convert to rgba with 0.5 opacity
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, 0.5)`;
  }
  return color;
};

/**
 * Truncate label to max length with ellipsis
 */
export const truncateLabel = (label, maxLength = 10) => {
  if (!label) return '?';
  if (label.length <= maxLength) return label;
  return label.slice(0, maxLength - 1) + '…';
};

/**
 * Check if a task is "pending" (actionable)
 * - Regular task: not completed
 * - Decision node: no selectedOption/answer chosen
 */
export const isTaskPending = (task) => {
  if (!task) return false;
  if (task.status === 'completed') return false;
  if (task.nodeType === 'decision' && (task.answer || task.selectedOption)) return false;
  return true;
};

/**
 * Check if an edge is "blocking" (source not resolved)
 * - Regular task: not completed
 * - Decision node branch: the chosen answer must match THIS branch
 */
export const isEdgeBlocking = (fromTask, edge) => {
  if (!fromTask) return false;
  // For decision nodes, check if THIS branch was chosen
  if (fromTask.nodeType === 'decision') {
    const chosenAnswer = fromTask.answer || fromTask.selectedOption;
    // If no choice made, all branches are blocking
    if (!chosenAnswer) return true;
    // If this edge has a branch, check if it matches the chosen answer
    if (edge?.branch) {
      return chosenAnswer !== edge.branch;
    }
    // Edge without branch from decision - shouldn't happen, but treat as unblocked if choice made
    return false;
  }
  // For regular tasks, blocking means not completed
  return fromTask.status !== 'completed';
};

